import { get, set } from 'idb-keyval';

export default {
    async getDeviceID() {
        return await get('deviceId');
    },

    async setDeviceId(deviceId) {
        await set('deviceId', deviceId);
    }
}
